/**
 * Whether the Item Manager remote actually loaded.
 *
 * NOT the same question as "is a remote URL configured". `main.ts` can hold a
 * perfectly good URL and still end up with no remote: the entry may 404, or —
 * measured on 2026-08-25 against the deployed dev host — be blocked by CORS,
 * because `remoteEntry.json` is served by the remote's own nginx and that nginx
 * sends no `Access-Control-Allow-Origin`. `initFederation` logs and resolves,
 * so the app boots fine; it is `loadRemoteModule` that then throws
 * `unknown remote item-manager` at navigation, in the user's face.
 *
 * Guarding the route on configuration therefore is not enough. It is guarded on
 * this, which is set only after the remote is confirmed present in the import map.
 */
let itemManagerRemoteReady = false;

export function markItemManagerRemoteReady(ready: boolean): void {
  itemManagerRemoteReady = ready;
}

export function isItemManagerRemoteReady(): boolean {
  return itemManagerRemoteReady;
}
